<template>
  <div class="text-grey">
    <template v-if="Object.keys(copyData).length">
      <div
        class="content padding-16 flex align-stretch"
        v-for="(value, name, index) in copyData"
        :key="name"
      >
        <div class="order padding-right-16 flex flex-y center-flex">
          <div
            class="flex flex-y center-flex"
            @click="hideItem(value, name, index)"
          >
            <span>{{ value.name }}</span>
            <van-icon name="arrow-down" class="direction" :ref="name" />
          </div>
        </div>
        <div class="flex-1">
          <van-cell-group
          class="cell-group"
            :border="false"
            :ref="name + index"
            :style="{ height: value.list.length === 1 ? '44px' : '88px' }"
          >
            <van-cell
              style="overflow-x: auto"
              class="text-line-1"
              title-class="text-grey"
              v-for="item in value.list"
              :key="item.id"
              :title="item.name"
              @click="$router.push(`/service/detail/${item.id}`)"
            />
          </van-cell-group>
        </div>
      </div>
    </template>

    <van-empty v-else description="暂无数据" />
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup } from 'vant'

import { deepCopy } from '@/utils/utils'
Vue.use(Cell).use(CellGroup)
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      // copyData: {}
    }
  },
  computed: {
    copyData () {
      const copyData = deepCopy(this.data)
      for (const key in copyData) {
        if (copyData[key].list.length <= 2) {
          copyData[key].needHide = false
        } else {
          copyData[key].needHide = true
          copyData[key].list = copyData[key].list.slice(0, 2)
        }
        copyData[key].hide = true
      }
      return copyData
    }
  },
  methods: {
    hideItem (obj, key, index) {
      if (!obj.needHide) return
      if (!obj.hide) {
        this.copyData[key].hide = true
        this.$refs[key][0].style.transform = 'rotate(0deg)'
        this.$refs[key + index][0].style.height = '88px'
        setTimeout(() => {
          this.copyData[key].list = this.data[key].list.slice(0, 2)
          this.$forceUpdate()
        }, 500)
      } else {
        this.copyData[key].hide = false
        this.$refs[key][0].style.transform = 'rotate(-180deg)'
        this.$refs[key + index][0].style.height =
          44 * this.data[key].list.length + 'px'
        this.copyData[key].list = this.data[key].list
        this.$forceUpdate()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    display: block;
    width: 1px;
    height: 100%;
    right: 0;
    bottom: 0;
    transform: scaleX(0.5);
    background-color: #eee;
  }
}

.content {
  position: relative;
  &:not(:last-child) {
    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 100%;
      height: 1px;
      left: 0;
      bottom: 0;
      transform: scaleY(0.5);
      background-color: #eee;
    }
  }
}

.direction {
  transition: all 0.5s ease;
}

.cell-group {
  overflow: hidden;
  transition: height 0.5s ease;
}
</style>
